import type { ReactNode } from 'react';
import { EmptyState } from '@dru/ui';
import { useAuth } from '../../../lib/auth';
import { PageHeader } from '../../../layouts/ConsoleShell';

/**
 * A page this role cannot read, opened from an old link or a typed address.
 * Says so plainly instead of rendering the API's 403 as "Something went wrong".
 */
export function RequirePermission({ need, title, what, children }: {
  need: string; title: string; what: string; children: ReactNode;
}) {
  const { permissions } = useAuth();
  if (permissions.has(need)) return <>{children}</>;
  return (
    <div>
      <PageHeader title={title} />
      <EmptyState
        title={`${what} ${what.endsWith('s') ? 'are' : 'is'} not part of your role`}
        hint="Ask your company administrator if you need access."
      />
    </div>
  );
}
